import {setIframeTitle} from '@packages/systems/core/utils/FigureUtils';
import type {VideoHelperResponse} from '@packages/systems/core/utils/EmbedlyUtils';

type VideoMetadata = VideoHelperResponse['metadata'];

export const aspectRatio = ({
  height,
  width,
}: {height?: number; width?: number} = {}) => {
  return height && width ? height / width : 0;
};

export type VideoEmbedValue = {
  embed: {
    meta?: VideoMetadata | Record<string, never>;
    url?: string;
    title?: string;
    type: 'video';
  };
  style?: {
    'padding-top': string;
  };
  value?: string;
};

export const buildVideoEmbedValue = (
  response: VideoHelperResponse
): VideoEmbedValue => {
  const meta = response.metadata;
  const url = response.url;

  return url === ''
    ? {
        embed: {
          type: 'video',
        },
      }
    : {
        embed: {
          meta: meta ?? {},
          url,
          title: meta?.title,
          type: 'video',
        },
        style: {
          'padding-top': `${aspectRatio(meta ?? {}) * 100}%`,
        },
        value: setIframeTitle(meta?.html || '', meta?.title ?? ''),
      };
};
